import React from 'react';
import { PackageOpen, CheckCircle2, Zap, Lock, ShieldCheck, Flame } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackEvent } from '../hooks/useMetaPixel';
export function Oferta() {
  const revealRef = useScrollReveal();
  const cardRef = useScrollReveal();
  return <section id="oferta" className="py-14 sm:py-[90px] px-6" style={{
    background: 'linear-gradient(160deg, #0f0c00, #0a0a0a)'
  }} data-id="element-246">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-247">
        <div className="text-center" data-id="element-248">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-249">
            Tu inversión hoy
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-250">
            Todo lo que recibes
            <br data-id="element-251" />
            por un precio que no tiene lógica
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-252"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1.1fr_1fr] gap-8 mt-14 items-start" data-id="element-253">
          {/* Tarjeta izquierda */}
          <div className="bg-gris-oscuro border border-oro/20 rounded-md p-9" data-id="element-254">
            <h3 className="font-montserrat font-black text-[14px] tracking-[3px] uppercase text-oro mb-6 pb-4 border-b border-oro/15 flex items-center gap-2.5" data-id="element-255">
              <PackageOpen size={18} data-id="element-256" /> Todo lo que incluye
            </h3>

            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-257">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-258" />
              <span data-id="element-259">
                <strong data-id="element-260">Ebook Pasta Sin Gluten</strong> — 80+ páginas con El
                Método Italiano™ completo
              </span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-261">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-262" />
              <span data-id="element-263">12 recetas paso a paso con fotos de resultado final</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-264">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-265" />
              <span data-id="element-266">
                Tabla de hidratación por tipo de harina (recurso único)
              </span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-267">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-268" />
              <span data-id="element-269">Guía de errores comunes y soluciones exactas</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-270">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-271" />
              <span data-id="element-272">5 salsas italianas adaptadas sin gluten</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-273">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-274" />
              <span data-id="element-275">Menú semanal completo listo para usar</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-276">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-277" />
              <span data-id="element-278">Lista de compras optimizada por receta</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-279">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-280" />
              <span data-id="element-281">Acceso digital inmediato, de por vida</span>
            </div>
            <div className="flex gap-3 items-start mb-3.5 text-[14px] text-white/80 leading-[1.6]" data-id="element-282">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-283" />
              <span data-id="element-284">
                <strong className="text-oro-claro" data-id="element-285">+ 3 Bonos exclusivos</strong>{' '}
                (ver abajo)
              </span>
            </div>

            <div className="mt-6 pt-5 border-t border-white/5" data-id="element-286">
              <div className="inline-flex items-center gap-2 bg-oro/10 border border-oro/40 rounded-sm px-3.5 py-1.5 text-[12px] text-oro-claro font-semibold tracking-[1px]" data-id="element-287">
                <span className="text-[11px] font-bold" data-id="element-288">TM</span> Incluye El
                Método Italiano™ completo
              </div>
            </div>
          </div>

          {/* Tarjeta derecha */}
          <div ref={cardRef} className="bg-gris-oscuro border border-oro rounded-md p-9 text-center relative reveal-scale" data-id="element-289">
            <img src="https://i.postimg.cc/25q93hHm/Copia-de-Sin-t-tulo.png" alt="Paquete completo Pasta Sin Gluten" className="w-full max-w-[300px] h-auto object-contain mx-auto mb-6 rounded-sm" data-id="element-290" />
            <p className="text-[18px] text-white/40 line-through mb-1.5" data-id="element-291">
              Valor real: USD $120
            </p>
            <div className="font-montserrat text-[56px] font-black text-oro-claro leading-none mb-2" data-id="element-292">
              $12
            </div>
            <p className="text-[13px] text-white/55 mb-6" data-id="element-293">
              Precio de lanzamiento — 90% de descuento
            </p>

            <div className="bg-oro/10 border border-oro/30 rounded-sm px-4 py-2.5 text-[13px] text-oro-claro mb-6 flex items-center justify-center gap-1.5" data-id="element-294">
              <Flame size={14} data-id="element-295" />
              <span data-id="element-296">
                Hoy lo obtienes por solo <strong data-id="element-297">USD $12</strong>. Este precio
                no es permanente.
              </span>
            </div>

            <a href="#cta-final" onClick={e => {
            e.preventDefault();
            trackEvent('InitiateCheckout', {
              content_name: 'Oferta CTA',
              value: 12,
              currency: 'USD'
            });
            document.getElementById('cta-final')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="btn-cta w-full flex items-center justify-center gap-2" data-id="element-298">
              <Zap size={18} className="fill-current" data-id="element-299" /> Obtener Acceso
              Inmediato
            </a>

            <div className="flex justify-center items-center gap-4 mt-3.5" data-id="element-300">
              <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-301">
                <Lock size={13} className="text-oro" data-id="element-302" /> SSL Seguro
              </span>
              <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-303">
                <ShieldCheck size={13} className="text-oro" data-id="element-304" /> 7 días de
                garantía
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}